import throwError from './throwError';

const throw403 = () => throwError(403, 'EACCES', 'Access denied');

export default throw403;
